/* SIMPLE CANVAS UTILITIES */
hrd.utils.CanvasUtils = hrd.Class.extend({
	GREEN: '#00BA37',
	YELLOW: '#FDB900',
	RED: '#F86467',
	init: function(options) {
		var defaults = {
			impl: 'hrd.utils.CanvasUtils',
		};
		this._super($.extend({}, defaults, options));
		this.toolbox = new hrd.Toolbox();
		var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
		window.requestAnimationFrame = requestAnimationFrame;
	},

	_defaultCircularLabelOptions: function() {
		return {
			color: '#00BA37',
			shadowColor: '#656565',
			textAlign: 'center',
			textBaseline: 'bottom',
			fillStyle: 'white',
		};
	},
	circularLabel: function(elementId, value, options) {
		if (value == undefined) {
			value = 0;
		}
		options = $.extend({}, this._defaultCircularLabelOptions(), options);
		var ctx = document.getElementById(elementId).getContext('2d');
		var cx = ctx.canvas.width;
		var cy = ctx.canvas.height;
		var PI = Math.PI;
		var PI2 = PI * 2;
		var lineWidth = 3;
		var radius = Math.min(cx, cy) / 2 - lineWidth;
		var innerRadius = radius - 2 * lineWidth;

		ctx.beginPath();
		ctx.clearRect(0, 0, cx, cy);
		cx = cx / 2;
		cy = cy / 2;
		ctx.arc(cx, cy, radius, 0, PI2);
		// shadow
		ctx.shadowOffsetX = 0;
		ctx.shadowOffsetY = 0;
		ctx.shadowBlur = 5;
		ctx.shadowColor = options.shadowColor;
		//
		ctx.fillStyle = options.color;
		ctx.fill();
		ctx.textAlign = options.textAlign;
		ctx.textBaseline = options.textBaseline;
		ctx.fillStyle = options.fillStyle;

		var digits = 1 + (value + "").length;
		var fSize = 14 + cy / (digits - 1);
		ctx.font = fSize + 'px monospace';
		ctx.fillText(value, cx, cy + 3 + fSize / 2, innerRadius);
		// ctx.stroke(); //bordo
	},

	_defaultProgressMeterOptions: function() {
		return {
			color: '#00BA37',
			fillColor: '#c3c3c3',
			shadowOffsetX: 0,
			shadowOffsetY: 0,
			shadowBlur: 5,
			shadowColor: '#656565',
			fillStyle: 'black',
			textAlign: 'center',
			constantStep: true,
			stepSize: 0.7,
			steps: 40,
			step: 0.7
		};
	},

	//progressMeter: function(elementId, startFrom, stopAt, color, fillColor, shadowOffsetX, shadowOffsetY, shadowBlur, shadowColor, uuid){
	progressMeter: function(elementId, startFrom, stopAt, options, uuid) {
		options = $.extend({}, this._defaultProgressMeterOptions(), options);

		// Verify input
		startFrom = (startFrom == undefined) ? 0.0 : parseFloat(startFrom);
		stopAt = (stopAt == undefined) ? 0.0 : parseFloat(stopAt);

		/* this part is needed to stop previuos computations if not needed anymore */
		const $element = $(`#${elementId}`);
		if (uuid == undefined) {
			/* first time... prepare step var */
			if (options.constantStep) {
				options.step = options.stepSize;
			} else {
				options.step = (stopAt - startFrom) / options.steps;
			}
			/* ------------------------------ */
			uuid = this.toolbox.generateMarker({ prefix: 'progress-' });
			$(`#${elementId}`).data('progress-uuid', uuid);
		} else {
			let current = $(`#${elementId}`).data('progress-uuid');
			if (current != uuid) {
				return;
			}
		}
		/* ------------------------------------------------------ */

		var ctx = document.getElementById(elementId).getContext('2d');

		if (startFrom > stopAt) {
			startFrom = stopAt;
		}
		// Layout
		var cw = ctx.canvas.width;
		var ch = ctx.canvas.height;

		var sim = 500;
		var start = 4.72;
		var diff = ((startFrom / 100) * Math.PI * 2 * 10).toFixed(2);
		var radius = (Math.min(cw, ch) - 2 * ctx.lineWidth) / 2 - 2;
		var lineWidth = 7;
		var innerRadius = Math.min(cw, ch) / 2 - 2 * lineWidth;

		ctx.clearRect(0, 0, cw, ch);
		// CENTER
		ctx.beginPath();
		ctx.arc(cw / 2, ch / 2, radius, 4, Math.PI * 2 * 10);
		ctx.strokeStyle = options.fillColor;
		ctx.stroke();

		// shadow
		ctx.shadowOffsetX = options.shadowOffsetX;
		ctx.shadowOffsetY = options.shadowOffsetY;
		ctx.shadowBlur = options.shadowBlur;
		ctx.shadowColor = options.shadowColor;
		//
		ctx.lineWidth = lineWidth;
		ctx.fillStyle = options.fillStyle;
		ctx.strokeStyle = options.color;
		ctx.textAlign = options.textAlign;
		// ctx.font="13px monospace";

		ctx.font = (innerRadius / 2) + 'px monospace';
		// params: x, y, radius, startAngle, endAngle [, counterclockwise]
		if (startFrom < 100 && startFrom < stopAt) {
			ctx.fillText(stopAt + '%', cw * .52 - 2, ch * .5 + 5, cw + 12);
			ctx.beginPath();
			ctx.arc(cw / 2, ch / 2, radius, start, diff / 10 + start, false);
			ctx.stroke();
		} else {
			// STOP RECURSION
			var diff = ((stopAt / 100) * Math.PI * 2 * 10).toFixed(2);
			ctx.fillText(stopAt + '%', cw * .52 - 2, ch * .5 + 5, cw + 12);
			ctx.beginPath();
			// arc
			ctx.arc(cw / 2, ch / 2, radius, start, diff / 10 + start, false);
			ctx.stroke();
			return;
		}
		// Recursive Call
		requestAnimationFrame(() => {
			let nextStart = Math.round((startFrom + options.step) * 100) / 100;
			this.progressMeter(elementId, nextStart, stopAt, options, uuid);
		});
	}
});
const canvasUtils = new hrd.utils.CanvasUtils();